import { useQuery } from '@tanstack/react-query';
import { getCrmMembers } from '@/api/crm';
import { useAuth } from '@/context/AuthContext';

/** Whether the Leads section is hidden for the signed-in CRM member. */
export const useCrmLeadsHidden = () => {
  const { user } = useAuth();
  const members = useQuery({
    queryKey: ['crm', 'members'],
    queryFn: getCrmMembers,
  });
  return (
    members.data?.find((member) => member.userId === user?.id)?.leadsHidden ??
    false
  );
};
